import React from 'react';
import LegalDocumentPage from '@/components/LegalDocumentPage';

export default function Privacy() {
    return <LegalDocumentPage docType="privacy" />;
}
